import { useFilterGroups } from './useListingLibFilters';
import useQuickFilters from './useQuickFilters';

/**
 * Returns true when at least one non-hidden filter is currently active —
 * either a filter group condition or a quick filter.
 *
 * Hidden filters (set via the provider's `hiddenFilter` prop) are excluded
 * from this check since they are always applied and not surfaced in the UI.
 */
export default function useHasNonHiddenFilters() {
  const filterGroups = useFilterGroups();
  const quickFilters = useQuickFilters();
  return filterGroups.some(filterGroup => filterGroup.filters.length > 0) || quickFilters.length > 0;
}